export default __webpack_public_path__ + "static/media/user.dce65ac3.png";